module.exports = {
  "version": "0.22.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 87
// module chunks = 4